import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ProjectKeyValEntry, ProjectKeyValMaxAgeRule } from '@shared/ProjectKeyValStore';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProjectKeyvalAdminService {

  private basePath = '/api/admin/project/projectkeyval';

  constructor(private http: HttpClient) { }

  public async getProjectKeyVals(projectId: string): Promise<ProjectKeyValEntry[]> {
    return firstValueFrom(this.http.get<ProjectKeyValEntry[]>(`${this.basePath}/read/${projectId}/list`));
  }

  public async deleteProjectKeyVal(userId: string, projectId: string, key: string, type: string) {
    return firstValueFrom(this.http.post(`${this.basePath}/write/${projectId}/delete`, { userId, key, type }));
  }

  public async deleteAllProjectKeyVals(projectId: string) {
    return firstValueFrom(this.http.post(`${this.basePath}/write/${projectId}/deleteAll`, {}));
  }

  public async updateProjectKeyVal(projectId: string, _id: string,  value: unknown) {
    return firstValueFrom(this.http.post(`${this.basePath}/write/${projectId}/update`, { _id,  value }));
  }

  public async getMaxAgeRules(projectId: string): Promise<ProjectKeyValMaxAgeRule[]> {
    return firstValueFrom(this.http.get<ProjectKeyValMaxAgeRule[]>(`${this.basePath}/read/${projectId}/maxage/list`));
  }

  public async addMaxAgeRule(projectId: string, keyPattern: string, maxAgeSeconds: number) {
    return firstValueFrom(this.http.post<ProjectKeyValMaxAgeRule>(`${this.basePath}/write/${projectId}/maxage/add`, { keyPattern, maxAgeSeconds }));
  }

  public async removeMaxAgeRule(projectId: string, ruleId: string) {
    return firstValueFrom(this.http.post(`${this.basePath}/write/${projectId}/maxage/remove`, { ruleId }));
  }

  public async updateMaxAgeRule(projectId: string, ruleId: string, keyPattern: string, maxAgeSeconds: number) {
    return firstValueFrom(this.http.post(`${this.basePath}/write/${projectId}/maxage/update`, { ruleId, keyPattern, maxAgeSeconds }));
  }

  public async getProjectKeyValUsers(projectId: string): Promise<Record<string, { name: string; guestId?: string }>> {
    return firstValueFrom(this.http.get<Record<string, { name: string; guestId?: string }>>(`${this.basePath}/read/${projectId}/users`));
  }
}
